import { render, staticRenderFns } from "./GlobalForm.vue?vue&type=template&id=1069c588&"
import script from "./GlobalForm.vue?vue&type=script&lang=js&"
export * from "./GlobalForm.vue?vue&type=script&lang=js&"
import style0 from "./GlobalForm.vue?vue&type=style&index=0&id=1069c588&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports